export const COGS_PAGE_SIZES = [10, 25, 50, 100] as const;
export type CogsPageSize = (typeof COGS_PAGE_SIZES)[number];
export const COGS_DEFAULT_PAGE_SIZE: CogsPageSize = 25;

/** Nested bill rollups per request while a page is calculating. */
export const COGS_CALC_BATCH = 5;

export function isCogsPageSize(n: number): n is CogsPageSize {
  return (COGS_PAGE_SIZES as readonly number[]).includes(n);
}

/** Pages after the one on screen, then earlier pages, for a background head start. */
export function laterPageOffsets(currentOffset: number, pageSize: number, totalCount: number): number[] {
  if (pageSize <= 0 || totalCount <= 0) return [];
  const offsets: number[] = [];
  for (let offset = currentOffset + pageSize; offset < totalCount; offset += pageSize) {
    offsets.push(offset);
  }
  for (let offset = 0; offset < currentOffset; offset += pageSize) {
    offsets.push(offset);
  }
  return offsets;
}
